import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
const main_index = (resolve) => {
  import("@/components/main_index").then(module => {
    resolve(module)
  })
};

const login = (resolve) => {
  import("@/components/login_register_forget/login").then(module => {
    resolve(module)
  })
};



const business_management = (resolve) => {
  import("@/components/business_management/business_management").then(module => {
    resolve(module)
  })
};


const authority_management = (resolve) => {
  import("@/components/authority_management/authority_management").then(module => {
    resolve(module)
  })
};

const upgradeTip_management = (resolve) => {
  import("@/components/upgradeTip_management/upgradeTip_management").then(module => {
    resolve(module)
  })
};



const router = new Router({
  routes: [
    {
      path: '/',
      redirect: "/login"
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: "登录"
      },
      component: login
    },


    {
      path: '/business_management',
      redirect: {
        name: "business_management"
      },
      component: main_index,
      children: [
        {
          path: "index",
          name: 'business_management',
          meta: {
            title: "企业管理"
          },
          component: business_management
        }
      ]
    },
    {
      path: '/authority_management',
      redirect: {
        name: "authority_management"
      },
      component: main_index,
      children: [
        {
          path: "index",
          name: 'authority_management',
          meta: {
            title: "版本权限设置"
          },
          component: authority_management
        }
      ]
    },
    {
      path: '/upgradeTip_management',
      redirect: {
        name: "upgradeTip_management"
      },
      component: main_index,
      children: [
        {
          path: "index",
          name: 'upgradeTip_management',
          meta: {
            title: "升级提醒设置"
          },
          component: upgradeTip_management
        }
      ]
    },
    {
      path: '/*',
      redirect: {
        name: "login"
      }

    },
  ]
});

router.beforeEach((to, from, next) => {
  if(to.name==="login"){
    next()
  }
  else {
    if((sessionStorage.getItem("is_login")==="true")){
      next()
    }
    else {
      next(false)
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js